/** @format */

const template = `
<ng-form name="{{$ctrl.name}}">
  <sis-legacy-local-date-editor
    [model]="$ctrl.localDate"
    (model-change)="$ctrl.handleDatePickerChange($event)"
    (validate)="$ctrl.handleValidityChange($event)"
    [name]="$ctrl.name"
    [label]="$ctrl.label"
    [required]="$ctrl.required"
    [disabled]="$ctrl.disabled"
    [min-date]="$ctrl.minDateString"
    [max-date]="$ctrl.maxDateString"
    [start-date]="$ctrl.initDateString"
    [scope]="$ctrl.$scope"
    name="{{$ctrl.name}}"
    ng-model="$ctrl.localDate"
    ng-required="$ctrl.required">
  </sis-legacy-local-date-editor>
</ng-form>
`;
export default template;
